<app-top-bar></app-top-bar>
<router-outlet class="mainContainer"></router-outlet>

<!-- 
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
-->